//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    content: {
      default: ''
    }
  }
};